export default "__VITE_ASSET__a9MatG2J__"